module.exports = __webpack_public_path__ + "img/china-bg.b77dceea.png";